import axios from "axios";

const AGENT_TONE_GENERATE_ENDPOINT = "https://promptgen-ai.digione.com.au/generate";

export async function generateAgentTonePreview(payload) {
  const response = await axios.post(AGENT_TONE_GENERATE_ENDPOINT, payload, {
    timeout: 30000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
}
